//路由设置
import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
	path:'/',
	redirect:'/login'
  },{
	path:'/login',
	name:'login',
	component:()=>import('../views/login')
  },{
	path:'/index',
	name:'index',
	component:()=>import('../views/index'),
	children:[{
			path:'/index/myindex',
			name:'myindex',
			component:()=>import('../views/index/myindex')
		},{
			path:'/index/setsch',
			name:'setsch',
			component:()=>import('../views/set/setsch')
		},{
			path:'/index/setjob',
			name:'setjob',
			component:()=>import('../views/set/setjob')
		},{
			path:'/index/setdj',
			name:'setdj',
			component:()=>import('../views/set/setdj')
		},{
			path:'/index/setsub',
			name:'setsub',
			component:()=>import('../views/set/setsub')
		},{
			path:'/index/addtch',
			name:'addtch',
			component:()=>import('../views/inf/addtch')
		},{
			path:'/index/myinf',
			name:'myinf',
			component:()=>import('../views/inf/myinf')
		},{
			path:'/index/tchlist',
			name:'tchlist',
			component:()=>import('../views/inf/tchlist')
		},{
			path:'/index/inputhour',
			name:'inputhour',
			component:()=>import('../views/data/inputhour')
		},{
			path:'/index/singeltotal',
			name:'singeltotal',
			component:()=>import('../views/data/singeltotal')
		},{
			path:'/index/integral',
			name:'integral',
			component:()=>import('../views/data/integral')
		},{
			path:'/index/tchhour',
			name:'tchhour',
			component:()=>import('../views/data/tchhour')
		},{
			path:'/index/tchtest',
			name:'tchtest',
			component:()=>import('../views/data/tchtest')
		},{
			path:'/index/assort',
			name:'assort',
			component:()=>import('../views/analysis/assort')
		},{
			path:'/index/hourinf',
			name:'hourinf',
			component:()=>import('../views/analysis/hourinf')
		},{
			path:'/index/othersort',
			name:'othersort',
			component:()=>import('../views/analysis/othersort')
		},
		// {
		// 	path:'/index/testdownload',
		// 	name:'testdownload',
		// 	component:()=>import('../views/library/testdownload')
		// },{
		// 	path:'/index/testpower',
		// 	name:'testpower',
		// 	component:()=>import('../views/library/testpower')
		// },{
		// 	path:'/index/testupload',
		// 	name:'testupload',
		// 	component:()=>import('../views/library/testupload')
		// },
		{
			path:'/index/xkw',
			name:'xkw',
			component:()=>import('../views/xkw/xkw')
		},
		{
			path:'/index/downlist',
			name:'downlist',
			component:()=>import('../views/xkw/downlist')
		}
	]
  },{
	path:'*',
	component:()=>import('../views/404')
  },{
	path:'/404',
	component:()=>import('../views/404')
  }
]

const router = new VueRouter({
  routes
})

export default router
